/** Notifications are per user: key the cache by the signed-in user's id so a sign-in
 * as someone else on the same tab never shows the previous user's list. */
export function notificationsQueryKey(userId: string | undefined) {
  return ['notifications', userId ?? null] as const;
}
